import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AlertsEventsResponse, DndSettingsResponse, DndUpdateSettingsRequest, DndUpdateSettingsResponse, PanelVisibility, PanelVisibilityRequest, SensorThresholdPayload, SensorThresholdResponse, SensorThresholdVisibilityResponse } from '../models/payload';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private http = inject(HttpClient);

  getAlertsEvents(shipmentsNumber: string): Observable<AlertsEventsResponse[]> {
    return this.http.get<AlertsEventsResponse[]>(
      environment.baseUrl + 'Settings/AlertEvents/' + shipmentsNumber + '/get-events',
    );
  }

  saveAlertsEvents(shipmentsNumber: string, payload: { eventId: number, impactId: number }[]): Observable<AlertsEventsResponse[]> {
    return this.http.post<AlertsEventsResponse[]>(
      environment.baseUrl + 'Settings/AlertEvents/' + shipmentsNumber + '/update-events', payload
    );
  }

  getDndSettings(shipmentsNumber: string): Observable<DndSettingsResponse> {
    return this.http.get<DndSettingsResponse>(
      environment.baseUrl + 'Settings/Dnd/' + shipmentsNumber + '/get-dnd',
    );
  }

  saveDndSettings(payload: DndUpdateSettingsRequest): Observable<DndUpdateSettingsResponse> {
    return this.http.post<DndUpdateSettingsResponse>(
      environment.baseUrl + 'Settings/Dnd/' + payload.customerNumber +'/update-dnd', payload
    );
  }

  getSensorThresholdDetails(shipmentsNumber: string): Observable<SensorThresholdVisibilityResponse> {
    return this.http.get<SensorThresholdVisibilityResponse>(
      environment.baseUrl + 'Settings/SensorThresholds/' + shipmentsNumber + '/get-sensor-thresholds',
    );
  }

  saveSensorThresholdDetails(shipmentsNumber: string, payload: SensorThresholdPayload[]): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      environment.baseUrl + 'Settings/SensorThresholds/' + shipmentsNumber + '/update-sensor-thresholds', payload
    );
  }

  getTrackingPageVisibility(panelVisibilityRequest: PanelVisibilityRequest): Observable<PanelVisibility> {
    return this.http.post<PanelVisibility>(
      environment.baseUrl + 'Settings/Visibility/panel-visibility-by-shipment',panelVisibilityRequest
    );
  }

}
